module.exports = __webpack_public_path__ + "static/media/cheeky_jeff.cff390b1.jpg";